import React, { FC, useEffect, useState } from "react";
import { createGlobalStyle } from "styled-components";
import MonthPicker from "./MonthPicker";
import { useDispatch } from "react-redux";
import Container from "saur_ui_library/src/Atoms/Container/Container";
import Card from "saur_ui_library/src/Molecules/Card/Card";
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Button from "saur_ui_library/src/Atoms/Input/Button/Button";
import { DECREASE_COUNT } from "../../../redux/actionType";
import { dateValues } from "../ecpHelper";

type Props = {
  seasonTitle: any;
  seasonStart?: any;
  seasonEnd?: any;
  showDeletion?: any;
  sendNewEnd: any;
  sendNewBegin: any;
};

const Season: FC<Props> = ({
  seasonTitle,
  seasonStart,
  seasonEnd,
  showDeletion,
  sendNewBegin,
  sendNewEnd,
}) => {
  //variables de saison
  const [startDate, setStartDate] = useState<any>(seasonStart);
  const [endDate, setEndDate] = useState<any>(seasonEnd);

  useEffect(()=>{
    if(seasonStart){
      setStartDate(seasonStart);
      setEndDate(seasonEnd);
    }
    else{
      setStartDate(dateValues[0]);
      setEndDate(dateValues[0]);
    }
   },[seasonStart,seasonEnd]);

  useEffect(() => {
    sendNewBegin(startDate);
    sendNewEnd(endDate);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startDate, endDate]);

  const dispatch = useDispatch();

  return (
    <Container className="seasonContainer sds-reset-style">
      <Styles />
      <Card className="seasonContent">
        <Word
          variant="p"
          className="season-title"
          automatedTestId="season-title"
          textStyle="title"
          value={seasonTitle}
        />
        <Container className="season-period">
          <MonthPicker
            className="date-start"
            title="Du"
            onChange={(e: any) => {
              setStartDate(e);
            }}
            selectedValue={startDate}
          />
          <MonthPicker
            className="date-end"
            title="Au"
            onChange={(e: any) => {
              setEndDate(e);
            }}
            selectedValue={endDate}
          />
          {showDeletion ? (
            <Button
              className="season-button"
              type="reset"
              mode="basic"
              onClick={() => {
                dispatch({
                  type: DECREASE_COUNT,
                });
                sendNewBegin(null);
                sendNewEnd(null);
              }}
            >
              <Word
                variant="p"
                className="season-delete"
                automatedTestId="season-delete"
                textStyle="normalBold"
                value="Supprimer"
              />
            </Button>
          ) : null}
        </Container>
      </Card>
    </Container>
  );
};
const Styles = createGlobalStyle`
.seasonContainer.sds-reset-style{
 width: fit-content;
 .seasonContent{
 background-color:#F5F8FB;
 overflow: visible !important;
 width: 257px;
 height: 486px;
 margin-right: 20px;
 }
 .season-delete{
  text-decoration: underline;
 }
 .season-button{
  margin-top: 150px;
  margin-left: 60px;
 }
}
.spinner{
    margin-left: 40%;
    margin-top:40%
}
`;
export default Season;